/**
 * WASM crypto — encryptJson được inject từ index.html.
 * Set VITE_WASM_URL trong .env để enable.
 */

const WASM_URL = import.meta.env.VITE_WASM_URL as string | undefined;

let _ready = false;
let _initPromise: Promise<void> | null = null;

export function initCrypto(): Promise<void> {
  if (_ready) return Promise.resolve();
  if (_initPromise) return _initPromise;

  if (!WASM_URL) {
    return Promise.resolve();
  }

  // Nếu wasm đã ready từ trước (index.html load xong trước main.ts)
  if (typeof (window as any).encryptJson === "function") {
    _ready = true;
    return Promise.resolve();
  }

  _initPromise = new Promise<void>((resolve, reject) => {
    const timeout = setTimeout(() => {
      reject(new Error("[crypto] timeout waiting for wasm-ready"));
    }, 10000);

    window.addEventListener("wasm-ready", () => {
      clearTimeout(timeout);
      _ready = true;
      console.log("[crypto] wasm ready ✓");
      resolve();
    }, { once: true });

    window.addEventListener("wasm-error", (e: Event) => {
      clearTimeout(timeout);
      const detail = (e as CustomEvent).detail;
      reject(new Error(`[crypto] wasm-error: ${detail}`));
    }, { once: true });
  }).catch((err) => {
    console.error("[crypto] wasm init failed", err);
    _initPromise = null;
  });

  return _initPromise;
}

export async function getSignature(sessionId: string, winnerId?: number | null): Promise<string> {
  if (!WASM_URL) {
    return sessionId;
  }
  await initCrypto();
  const encryptJson = (window as any).encryptJson;
  if (typeof encryptJson !== "function") {
    console.warn("[crypto] encryptJson not available, using sessionId as-is");
    return sessionId;
  }
  const payload = JSON.stringify({
    session_id: sessionId,
    ...(winnerId != null ? { winner_id: winnerId } : {}),
  });
  const result = encryptJson(payload);
  if (!result) {
    console.warn("[crypto] encryptJson returned empty");
    return sessionId;
  }
  return result;
}

export function isCryptoReady(): boolean {
  return _ready;
}

export function encryptSessionId(sessionId: string): string {
  if (!WASM_URL) return sessionId;
  const encryptJson = (window as any).encryptJson;
  if (typeof encryptJson !== "function") return sessionId;
  const payload = JSON.stringify({ session_id: sessionId });
  return encryptJson(payload) || sessionId;
}
